<script setup lang="ts">
const { t } = useI18n()

const findOneLocalizedContentWithFallback = useFindOneLocalizedContentWithFallback()
const { data, error } = await useAsyncData('page-privacy-cookies', () => findOneLocalizedContentWithFallback('cookies'))
if (error.value) {
  throw createError(error.value)
}

useSeoText({ title: t('commons.links.privacy-cookies') })
</script>

<template>
  <div>
    <AppPageSection>
      <AppLayoutTwoOneThird>
        <template #two-third>
          <ContentRenderer
            v-if="data"
            :value="data"
            class="prose lg:prose-lg"
          />
          <YscDivider class="my-12" />
          <!--
            FIXME: get date cc https://gitlab.com/yescapa-dev/vuejs/-/merge_requests/1903#note_1822944038
            <p>{{ $t('commons.last_update_on_dynamic', { date_string: $d(new Date(data?.updatedAt), 'Y.numeric M.long D.numeric') }) }}</p>
          -->
        </template>
        <template #one-third />
      </AppLayoutTwoOneThird>
    </AppPageSection>
  </div>
</template>
